import { render, staticRenderFns } from "./m-pdf-viewer.vue?vue&type=template&id=802f812c&lang=pug"
import script from "./m-pdf-viewer.vue?vue&type=script&lang=js"
export * from "./m-pdf-viewer.vue?vue&type=script&lang=js"
import style0 from "./m-pdf-viewer.vue?vue&type=style&index=0&id=802f812c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports